import { render, staticRenderFns } from "./MenuItemFooter.vue?vue&type=template&id=f670a68e&scoped=true&"
import script from "./MenuItemFooter.vue?vue&type=script&lang=js&"
export * from "./MenuItemFooter.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemFooter.vue?vue&type=style&index=0&id=f670a68e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670a68e",
  null
  
)

export default component.exports